export default __webpack_public_path__ + "static/media/about-section-05.f6f9d4ea.png";